import { render, staticRenderFns } from "./home-view.vue?vue&type=template&id=72ca1e06&scoped=true&"
import script from "./home-view.vue?vue&type=script&lang=js&"
export * from "./home-view.vue?vue&type=script&lang=js&"
import style0 from "./home-view.vue?vue&type=style&index=0&id=72ca1e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ca1e06",
  null
  
)

export default component.exports